/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface WorkflowScriptUpdateDto
 */
export interface WorkflowScriptUpdateDto {
    /**
     *
     * @type {string}
     * @memberof WorkflowScriptUpdateDto
     */
    workflowScriptId?: string;
    /**
     *
     * @type {string}
     * @memberof WorkflowScriptUpdateDto
     */
    workflowId?: string;
    /**
     *
     * @type {string}
     * @memberof WorkflowScriptUpdateDto
     */
    name?: string | null;
    /**
     *
     * @type {string}
     * @memberof WorkflowScriptUpdateDto
     */
    script?: string | null;
}

export function WorkflowScriptUpdateDtoFromJSON(json: any): WorkflowScriptUpdateDto {
    return WorkflowScriptUpdateDtoFromJSONTyped(json, false);
}

export function WorkflowScriptUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowScriptUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'workflowScriptId': !exists(json, 'workflowScriptId') ? undefined : json['workflowScriptId'],
        'workflowId': !exists(json, 'workflowId') ? undefined : json['workflowId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'script': !exists(json, 'script') ? undefined : json['script'],
    };
}

export function WorkflowScriptUpdateDtoToJSON(value?: WorkflowScriptUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'workflowScriptId': value.workflowScriptId,
        'workflowId': value.workflowId,
        'name': value.name,
        'script': value.script,
    };
}

